import type { SectionDraftDetailLecturesItem } from './sectionDraftDetailLecturesItem';

/**
 * 강의 초안의 섹션 상세 정보 (업데이트 요청 시 사용)
 */
export interface SectionDraftDetail {
  /**
   * 섹션 ID (새로 생성 시 null 가능, 기존 ID는 Long)
   * @nullable
   */
  id?: number | null;
  /**
   * 해당 섹션에 포함된 강의(레슨) 목록
   * @nullable
   */
  lectures?: SectionDraftDetailLecturesItem[] | null;
  /** 강의 내 섹션 순서 */
  order: number;
  /** 섹션 제목 */
  title: string;
}
